import type { EventMeta, EventProvider, GlobalContext } from '../types.ts'

export interface DatadogRumInstance {
  addAction(name: string, context?: Record<string, unknown>): void
}

export function datadogProvider(instance: DatadogRumInstance): EventProvider {
  return {
    name: 'datadog',
    send(
      event: EventMeta,
      data: Record<string, unknown>,
      context: GlobalContext,
    ) {
      if (!event.backends.datadog) return
      const payload: Record<string, unknown> = { ...data }
      if (context.encounterId) payload.encounterId = context.encounterId
      if (context.patientId) payload.patientId = context.patientId
      payload.service = context.service
      payload.version = context.version
      instance.addAction(event.name, payload)
    },
  }
}
